export default [
  {
    name: 'ActivitiesTypesCreate',
    path: 'settings/activities-type/new',
    component: () => import('pages/settings/activities-type/ActivitiesTypeForm.vue')
  },
  {
    name: 'ActivitiesTypesEdit',
    path: 'settings/activities-type/:id/edit',
    component: () => import('pages/settings/activities-type/ActivitiesTypeForm.vue')
  },
  {
    name: 'ActivitiesTypesList',
    path: 'settings/activities-type',
    component: () => import('pages/settings/activities-type/ActivitiesTypeList.vue')
  }
]
